<ng-container *ngIf="request">
  <div class="container section__creditResume h-full">
    <div class="wrapper">
      <div class="sectionContainer fadeinright animation-duration-200">
        <article class="pb-30">
          <div class="mainInfoBox">
            <div class="mainInfoBox__title">
              <h1>¡Kredicash Express aprobado!</h1>
            </div>
            <div class="mainInfoBox__credit">
              <span>Tienes autorizados</span>
              <div class="credit">
                <div class="icon">
                  <app-money-icon></app-money-icon>
                </div>

                <div class="value">
                  <p>
                    <small class="currency">{{ country.currency }}</small>{{ topUpLoan?.consolidation?.total_new_credit ?? 0 | currency: country.currency : '' : '1.2-2' : country.locale }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="resumeBox pt-30">
            <div class="creditInfo mb-12" *ngIf="topUpLoan.current_loan">
              <h2>{{ 'Sobre tu crédito vigente:' | termReplace }}</h2>
              <p>Tu saldo pendiente actual es: <strong>{{topUpLoan.current_loan.quota_amount ??  0 | currency}}</strong>.</p>
            </div>

            <div class="creditConsolidation mb-23" *ngIf="topUpLoan.consolidation">
              <div class="creditConsolidation__content">
                <div class="creditConsolidation__items">
                  <ul>
                    <li>
                      <div class="title">{{ 'Saldo de tu crédito vigente' | termReplace }}</div>
                      <div class="value">+ {{(topUpLoan.current_loan.balance ?? 0) - (topUpLoan.consolidation.discount ?? 0) | currency}}</div>
                    </li>
                    <li>
                      <div class="title">{{ 'Kredicash Express aprobado' | termReplace }}</div>
                      <div class="value">+ {{topUpLoan.consolidation.total_new_credit | currency}}</div>
                    </li>
                    <li class="finalItem">
                      <div class="title">Total unificado</div>
                      <div class="value">{{topUpLoan.consolidation.total_financed | currency}}</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="productDetails mb-15">
              <i><app-hand-money-icon></app-hand-money-icon></i>
              <h2>{{ 'El desembolso de tu KrediCash Express será:' | termReplace }}</h2>
              <p>{{topUpLoan?.consolidation?.total_new_credit ?? 0 | currency}}</p>
            </div>

            <div class="creditSelector">
              <div class="creditSelector__title">
                <h2>Tu nuevo plan de pago será de:</h2>
                <p>Selecciona una opción</p>
              </div>

              <div class="creditSelector__selector">
                <p-selectButton [options]="quotes" [(ngModel)]="selectedQuote" optionLabel="text" optionValue="id" [allowEmpty]="false">
                  <ng-template let-option pTemplate="item">
                    <div class="creditSelector__selectorItem">
                      <div class="radioItem"></div>
                      <p>
                        {{ option.installments }} cuotas quincenales de <strong>{{ option.amount}}</strong>
                      </p>
                    </div>
                  </ng-template>
                </p-selectButton>
              </div>
            </div>

            <div class="creditInfo pt-10" *ngIf="topUpLoan?.first_payment_date">
              <p>Tu primera fecha de pago es el <strong class="highlight">{{ topUpLoan.first_payment_date | date:'dd/MM/yyyy' }}</strong>.</p>
            </div>
          </div>
        </article>

        <footer>
          <div class="footer__content">
            <button pButton pRipple label="Si, estoy de acuerdo" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onNextStep()" [disabled]="!selectedQuote"></button>

            <div class="footer__float">
              <p-button label="No estoy de acuerdo" icon="pi pi-angle-left" iconPos="left" [text]="true" [plain]="true" (click)="showConfirmReject()"></p-button>
            </div>
          </div>
        </footer>
      </div>
    </div>
  </div>
</ng-container>

<p-dialog [(visible)]="confirmVisible" [modal]="true" [draggable]="false" [resizable]="false" [closable]="true" position="bottom">
  <div class="dialog">
    <div class="container">
      <div class="wrapper">
        <div class="dialog__info">
          <h2>Confirmación</h2>
          <p>{{ '¿Estás seguro que no deseas continuar con el crédito?' | termReplace }}</p>
        </div>
        <div class="dialog__btn dialog__btn--flex">
          <div class="item">
            <button pButton pRipple label="Cancelar" icon="pi pi-times" iconPos="left" class="p-button-secondary p-button-raised p-button-rounded w-full" (click)="confirmVisible=false"></button>
          </div>
          <div class="item">
            <button pButton pRipple label="Si, rechazar" icon="pi pi-check" iconPos="left" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onRejectRequest()"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
